document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('.product-card input[data-variant-id]')) return;

    const productCard = input.closest('product-card');
    const variantIdInput = productCard && productCard.querySelector('.yg-card-add-form__variant-id');
    if (variantIdInput) variantIdInput.value = input.dataset.variantId || variantIdInput.value;
  });

  class YGCartBackup {
    static BACKUP_KEY = 'yg_cart_backup';
    static BACKUP_TIME_KEY = 'yg_cart_backup_time';
    static BACKUP_EXPIRY = 30 * 60 * 1000;
    static _instance = null;

    _isRestoring = false;

    constructor() {
      if (YGCartBackup._instance) return YGCartBackup._instance;
      YGCartBackup._instance = this;
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.checkAndRestore();
      });
    }

    async backup() {
      try {
        const cartData = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json());
        if (cartData.items && cartData.items.length > 0) {
          localStorage.setItem(YGCartBackup.BACKUP_KEY, JSON.stringify(cartData));
          localStorage.setItem(YGCartBackup.BACKUP_TIME_KEY, Date.now().toString());
        } else {
          this.clear();
        }
        return cartData;
      } catch (_) {
        return null;
      }
    }

    clear() {
      localStorage.removeItem(YGCartBackup.BACKUP_KEY);
      localStorage.removeItem(YGCartBackup.BACKUP_TIME_KEY);
    }

    hasValidBackup() {
      const backupData = localStorage.getItem(YGCartBackup.BACKUP_KEY);
      const backupTime = localStorage.getItem(YGCartBackup.BACKUP_TIME_KEY);
      if (!backupData || !backupTime) return false;
      const elapsed = Date.now() - parseInt(backupTime, 10);
      if (elapsed > YGCartBackup.BACKUP_EXPIRY) {
        this.clear();
        return false;
      }
      return true;
    }

    async _addItemsSequentially(items) {
      for (const item of items) {
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: item.id, quantity: item.quantity, properties: item.properties || {} }),
          });
        } catch (_) {}
      }
    }

    restore() {
      const backup = localStorage.getItem(YGCartBackup.BACKUP_KEY);
      if (!backup || this._isRestoring || window.location.pathname.includes('/checkout')) return;
      this._isRestoring = true;

      const cleanup = () => {
        this.clear();
        this._isRestoring = false;
      };

      try {
        const cartData = JSON.parse(backup);
        if (!cartData || !cartData.items || cartData.items.length === 0) {
          cleanup();
          return;
        }

        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(() => this._addItemsSequentially(cartData.items.map((item) => ({ id: item.id, quantity: item.quantity, properties: item.properties }))))
          .then(() => fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: cartData.note || '', attributes: cartData.attributes || {} }),
          }))
          .then(() => {
            cleanup();
            window.location.reload();
          })
          .catch(() => cleanup());
      } catch (_) {
        cleanup();
      }
    }

    checkAndRestore() {
      const isCartPage = window.location.pathname === '/cart' || window.location.pathname === '/cart/';
      if (isCartPage && this.hasValidBackup()) this.restore();
    }
  }

  if (!window.YGCartBackup) window.YGCartBackup = new YGCartBackup();
  window.YGCartBackup.checkAndRestore();

  class YGProductBundleHandler {
    static getSectionRoot(trigger) {
      return trigger.closest('[id^="shopify-section-"]') || document;
    }

    static getProductForm(section) {
      return section.querySelector('form[is="product-form"], form[action*="/cart/add"]')
        || document.querySelector('.shopify-section--main-product form[is="product-form"], .shopify-section--main-product form[action*="/cart/add"]');
    }

    static getMainItem(section, form) {
      if (!form) return null;
      const idInput = form.querySelector('input[name="id"]:not([disabled])') || form.querySelector('input[name="id"]');
      const formId = form.id || '';
      let qtyInput = null;
      if (formId) qtyInput = section.querySelector(`input[name="quantity"][form="${formId}"]`) || document.querySelector(`input[name="quantity"][form="${formId}"]`);
      if (!qtyInput) qtyInput = section.querySelector('.product-info__quantity-selector input[name="quantity"]') || document.querySelector('.product-info__quantity-selector input[name="quantity"]');

      const id = parseInt(idInput && idInput.value, 10);
      const quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      if (!Number.isFinite(id) || id <= 0) return null;
      return { id, quantity };
    }

    static getPartItems(section) {
      const partsRoot = section.querySelector('yg-product-parts') || document.querySelector('yg-product-parts');
      if (!partsRoot) return [];
      return Array.from(partsRoot.querySelectorAll('.yg-parts-item[data-selected="true"][data-available="true"]'))
        .map((item) => {
          const qtyNode = item.querySelector('yg-qty-selector input');
          return { id: parseInt(item.dataset.variantId, 10), quantity: Math.max(1, parseInt(qtyNode && qtyNode.value, 10) || 1) };
        })
        .filter((item) => Number.isFinite(item.id) && item.id > 0);
    }

    static getItems(trigger) {
      const section = this.getSectionRoot(trigger);
      const form = this.getProductForm(section);
      const mainItem = this.getMainItem(section, form);
      if (!mainItem) return null;
      return { section, items: [mainItem].concat(this.getPartItems(section)) };
    }

    static async updateCartCountBubble() {
      const cartCount = document.querySelector('#cart-count-bubble, [data-cart-count], .header__cart-count-bubble');
      if (!cartCount) return;
      try {
        const cartData = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json());
        if (cartData && typeof cartData.item_count === 'number') cartCount.textContent = cartData.item_count;
      } catch (_) {}
    }

    static resetSelectors(section) {
      section.querySelectorAll('.product-info__quantity-selector input[name="quantity"]').forEach((input) => {
        input.value = '1';
      });
      section.querySelectorAll('yg-qty-selector').forEach((selector) => {
        const input = selector.querySelector('input');
        if (!input) return;
        input.value = '1';

        const minusBtn = selector.querySelector('[data-action="minus"]');
        const plusBtn = selector.querySelector('[data-action="plus"]');
        const max = parseInt(selector.dataset.max, 10) || 0;
        if (minusBtn) minusBtn.disabled = true;
        if (plusBtn) plusBtn.disabled = max === 1;
      });
    }
  }

  class YGAddToCart extends HTMLButtonElement {
    constructor() {
      super();
      this._isSubmitting = false;
      this.addEventListener('click', this.handleClick.bind(this));
    }

    async handleClick(event) {
      event.preventDefault();
      if (this._isSubmitting || this.hasAttribute('disabled')) return;

      const result = YGProductBundleHandler.getItems(this);
      if (!result || !result.items.length) return;

      this._isSubmitting = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: result.items }),
        });

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        await YGProductBundleHandler.updateCartCountBubble();

        const cartDrawerTrigger = document.querySelector('[aria-controls="cart-drawer"]');
        if (cartDrawerTrigger) cartDrawerTrigger.click();
      } finally {
        this._isSubmitting = false;
      }
    }
  }

  if (!window.customElements.get('yg-add-to-cart')) {
    window.customElements.define('yg-add-to-cart', YGAddToCart, { extends: 'button' });
  }

  class YGBuyItNow extends HTMLElement {
    constructor() {
      super();
      this._isSubmitting = false;
      const button = this.querySelector('.yg-buy-it-now-button');
      if (button) button.addEventListener('click', (event) => this.buttonClick(event));
    }

    async buttonClick(event) {
      event.preventDefault();
      if (this._isSubmitting) return;

      const result = YGProductBundleHandler.getItems(this);
      if (!result || !result.items.length) return;

      this._isSubmitting = true;
      try {
        if (window.YGCartBackup) await window.YGCartBackup.backup();

        await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: result.items }),
        });

        YGProductBundleHandler.resetSelectors(result.section);
        window.location.href = '/checkout';
      } finally {
        this._isSubmitting = false;
      }
    }
  }

  if (!window.customElements.get('yg-buy-it-now')) {
    window.customElements.define('yg-buy-it-now', YGBuyItNow);
  }

  class YGGalleryPagination {
    constructor() {
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.setupPaginationListeners();
        });
      } else {
        this.setupPaginationListeners();
      }
    }

    setupPaginationListeners() {
      const mediaCarousels = document.querySelectorAll('media-carousel');
      mediaCarousels.forEach((carousel) => {
        this.attachCarouselListener(carousel);
      });
    }

    attachCarouselListener(carousel) {
      const wrapper = carousel.closest('.product-gallery__media-list-wrapper');
      if (!wrapper) return;

      const pagination = wrapper.querySelector('.yg-gallery-pagination');
      if (!pagination) return;

      const updateHandler = () => {
        this.updatePagination(carousel, pagination, wrapper);
      };

      carousel.addEventListener('scroll', updateHandler, { passive: true });
      carousel.addEventListener('change', updateHandler);

      const observer = new MutationObserver(updateHandler);
      observer.observe(carousel, {
        attributes: true,
        subtree: true,
        childList: true,
      });

      this.updatePagination(carousel, pagination, wrapper);
    }

    updatePagination(carousel, pagination, wrapper) {
      const mediaItems = Array.from(carousel.querySelectorAll('.product-gallery__media:not([hidden])'));
      if (mediaItems.length === 0) return;

      let currentIndex = 1;
      const scrollLeft = carousel.scrollLeft;
      const itemWidth = carousel.offsetWidth;

      mediaItems.forEach((item, index) => {
        const itemLeft = item.offsetLeft;
        if (itemLeft <= scrollLeft + itemWidth / 2) {
          currentIndex = index + 1;
        }
      });

      const currentMediaItem = carousel.querySelector('.product-gallery__media[style*="display"]');
      const isVideoActive = currentMediaItem && currentMediaItem.dataset.mediaType === 'video';

      const paginationCurrent = pagination.querySelector('.yg-gallery-pagination__current');
      if (paginationCurrent) {
        paginationCurrent.textContent = currentIndex;
      }

      if (isVideoActive) {
        wrapper.classList.add('yg-media-video-active');
      } else {
        wrapper.classList.remove('yg-media-video-active');
      }
    }
  }

  if (!window.YGGalleryPagination) {
    window.YGGalleryPagination = new YGGalleryPagination();
  }
});
